import React from 'react';
import { get, compact, isNumber, filter, split } from 'lodash';
import { SubmissionError } from 'redux-form';
import {
  postCalendarPricing,
  updateShowVariablePriceForm,
  fetchCalendarPricing
} from '../../../app-main/actions/calendarPricing';
import { TimeMap } from '../../../elements-date-time/data/time-data';
import { toggleBanner } from '../../../app-main/actions/banner';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../../../shared-components/hocs/sharedIntlProviderHOC';

const getFormattedTime = (index) => {
  return {
    time: {
      h: get(TimeMap, `[${index}].h`),
      m: get(TimeMap, `[${index}].m`)
    }
  };
};

const onSubmitVariablePrice = (
  {
    pricingType,
    name,
    rate,
    afterStart,
    customStart,
    customEnd,
    dows
  },
  dispatch,
  props
) => {
  const { _id, longitude, latitude } = get(props, 'listing', {});

  const dowVals = dows.map((dow, index) => {
    return dow ? index + 1 : null;
  });

  // remove falsy values from array
  const selectedDows = compact(dowVals);
  const payload = {
    longitude,
    latitude,
    name,
    dows: selectedDows,
    hourly_rate: Number(rate),
    all_day: 'all-day' === pricingType
  };
  const start = afterStart || 0 === afterStart ? afterStart : customStart;

  if (isNumber(start)) {
    payload.start = getFormattedTime(start);
  }

  if (customEnd) {
    payload.end = getFormattedTime(customEnd);
  }
  const accessToken = get(props, 'accessToken', '');
  const priceErrorMessage = <FormattedMessage id="hosting.on_submit_variable_price.error_message" defaultMessage="Something happened. Please refresh and try again later." />;

  return dispatch(postCalendarPricing(payload, _id, accessToken))
    .then((pricingResponse) => {
      return dispatch(fetchCalendarPricing(_id))
        .then((calendarPrices) => {
          const groupId = get(pricingResponse, 'info.group_id');
          const pricingData = filter(get(calendarPrices, 'prices_by_group', []), { group_id: groupId })[0];
          const value = get(props, 'listing.prices.0.value', 0);

          analyticsIntegrations.calendarPricingAction('price_by_day_added',
            Object.assign({}, pricingData, { listing_id: _id, value }));
        });
    })
    .then(() => {
      dispatch(updateShowVariablePriceForm(false));
      dispatch(toggleBanner('save'));
    })
    .catch((error) => {
      let errorString = priceErrorMessage;
      const errorType = get(error, 'error_type');

      if ('overlapping_prices' === errorType) {
        const locale = split(SharedIntlProviderHOC.getLocale(), '-', 1)[0];
        const errors = get(error, 'error');
        const dowString = Object.keys(errors)
          .map((dow) => moment().locale(locale).isoWeekday(parseInt(dow, 10)).format('ddd'))
          .join(', ');
        errorString = <FormattedMessage id="hosting.on_submit_variable_price.rate_conflict_error_message" defaultMessage="This rate currently conflicts with rates on: {dowString}" values={{dowString: dowString}} />;
      }
      throw new SubmissionError({
        _error: errorString
      });
    });
};

export default onSubmitVariablePrice;
